import React from 'react';
import defaultClasses from './indicator.css';
import { mergeClasses } from '../../classify';
import { Loader as LoaderIcon } from 'react-feather';
import Icon from '../Icon';
var LoadingIndicator = props => {
  var classes = mergeClasses(defaultClasses, props.classes);
  var className = props.global ? classes.global : classes.root;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Icon, {
    src: LoaderIcon,
    size: 64,
    classes: {
      icon: classes.indicator
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.message
  }, props.children));
};
export default LoadingIndicator;